var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedChilly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2963",
    viewBox: "0 0 56.301 99.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-64.702 -335.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6312",
    transform: "matrix(.73509 0 0 .73509 -129.17 566.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3791",
    transform: "matrix(1.3301 0 0 1.3301 148.86 -644.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3793",
    style: {
      fillRule: "evenodd",
      fill: "#a11c25"
    },
    d: "m123.63 259.33c3.23-3.31 12.17-1.26 15.86 1.4 0.45 0.25 2.15-1.58 4.45-5.44-1.06-3.96-11.01-7.59-17.27-6.64-5.44 0.62-6.16 2.37-10.28 2.68-1.47-3.21-17.349-1.7-21.056 2.99-2.821 4.09-3.211 10.14-4.931 14.73-3.168 10.49-5.358 21.06-3.135 32.03 3.534 13.93 14.572 30.87 28.182 39.4 3.46 0.86 2.29 6.64 6.41 9.18 3.23 2.83 9.06-3.73 8.95-6.99 1.16-9.16-4.88-16.97-10.55-23.55 0.74-2.45-0.11-4.91-1.71-9.02-1.03-4.76-1.62-13.49-6.36-17.58-0.14-2.29 3.27-5.89 1.52-10.72 3.45-0.66 6.55-3.94 7.48-5.82 1.89-4.25 7.25-12.9 2.44-16.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3795",
    style: {
      fillRule: "evenodd",
      fill: "#e11521"
    },
    d: "m120.98 259.58c3.11-3.18 9.89-5.78 13.44-3.22 2.14 1.92 5.27 2.83 5.36 2.66 0.43-0.78 2.08-3.16 2.59-3.33-1.03-3.81-8.77-6.7-14.8-5.78-5.24 0.6-7.76 3.2-11.73 3.5-1.41-3.1-14.56-2.56-18.131 1.96-2.715 3.93-3.396 8.84-5.051 13.26-3.049 10.09-5.767 20.89-3.627 31.44 3.402 13.41 15.239 30.32 28.349 38.54 3.32 0.82 0.07 3.95 3.72 7.92 3.12 2.72 6.9-2.07 6.8-5.21 1.11-8.81-4.4-16.64-9.86-22.97 0.72-2.36-0.1-5.94-1.64-9.9-0.99-4.58-1.86-11.76-6.43-15.7-0.43-2.21 4.06-6.58 2.38-11.24 3.32-0.63 6-4.4 6.89-6.21 1.82-4.09 6.37-12.11 1.74-15.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3797",
    style: {
      fillRule: "evenodd",
      fill: "#d01418"
    },
    d: "m107.05 261.16l-7.912 0.64-7.281 30.7 0.95 13.62 8.233 11.08 9.81 12.34 11.71 11.72v5.38l1.27-5.07-10.76-12.66-10.13-15.51-6.018-9.18-0.633-18.68 2.216-6.33 3.795-11.71 4.75-6.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3799",
    style: {
      strokeLinejoin: "round",
      stroke: "#e64a16",
      strokeWidth: 3.8864,
      fill: "none"
    },
    d: "m114.47 263.7l-3.37-0.64 1.96 6.02-5.89 2.21 4.77 3.49-5.89 0.63 3.09 6.33-4.77 1.9 4.77 3.8-6.74 1.9 4.18 9.18-4.77-0.2 2.52 1.26-0.56 2.22 7.01 2.85-3.36 5.7 5.05 0.31-4.77 6.34 6.17-2.22-1.96 5.06 2.52 2.22 1.12 4.12 3.09-0.32 1.4 4.43 2.52 0.95"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3801",
    style: {
      fillRule: "evenodd",
      fill: "#01632a"
    },
    d: "m304.42-306.87c0.91 0.5 3.05 5.76 5.53 6.37 0.6-1.67 5.77-3.94 8.54-4.76s8.19-0.43 9.5 0.6c1.47 1.16 4.83 2.86 6.36 3.6 0.86-0.75 3.11-4.03 3.27-4.7-14.35-11.29-24.4-5.53-33.2-1.11z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedChilly);
export default __webpack_public_path__ + "static/media/red-chilly.517bd168.svg";
export { ForwardRef as ReactComponent };